import { Injectable } from '@angular/core';
import $ from 'jquery';
import { Observable } from 'rxjs/internal/Observable';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';

@Injectable({ providedIn: 'root' })
export class PrintTicketService {
    constructor(private windowRef: WindowRef) {}

    print(): Observable<any> {
        // $templateRequest('/app/components/directives/print-ticket/print-ticket.html' + appConfig.version + 2).then(function (template) {
        // templates the HTML template as a string

        // Let's put it into an HTML element and parse any directives and expressions
        // in the code. (Note: This is just an example, modifying the DOM from within
        // a controller is considered bad style.)

        return new Observable((observer) => {
            setTimeout(() => {
                const ticket = $('#ticket-detail-panel')[0].innerHTML;

                setTimeout(() => {
                    $('html').append('<iframe id="printf" style="display: none" name="printf"></iframe>'); // an iFrame is added to the html content, then your div's contents are added to it and the iFrame's content is printed

                    const mywindow = this.windowRef.nativeWindow.frames['printf'];
                    mywindow.document.write(
                        '<html id="print-ticket-html"><head><title></title>' + // Your styles here, I needed the margins set up like this
                            //     + '<link href="' + window.location.origin + '/app/components/directives/print-ticket/print-ticket.css"' + ' rel="stylesheet" >'
                            '<style>' +
                            '*{-webkit-print-color-adjust: exact;}' +
                            'html {overflow: auto !important;} ' +
                            '#print-ticket .ticket-details {height: auto !important;}' +
                            '.tickets-list,' +
                            '.ticket-details.chat-ticket,' +
                            '.ticket-details.chat-ticket .ticket-body,' +
                            '            .ticket-details.chat-ticket .ticket-body .ticket-stream,' +
                            '         .ticket-details.chat-ticket .ticket-body .ticket-stream > div {' +
                            '                          height: auto !important;' +
                            '                       overflow-y: visible !important;' +
                            '                }' +
                            '\n' +
                            '.tickets-list {' +
                            ' padding-top: 0 !important;' +
                            '}' +
                            '#print-ticket-html { overflow: visible;}' +
                            '#print-ticket-html body {overflow: visible; height: auto;}' +
                            '#print-ticket .ticket-details.chat-ticket .replies-block-chat{flex: none;}' +
                            'app-ticket-details > div.full-height { height: auto !important; }' +
                            '</style>' +
                            '</head><body style="min-width: 0; height: auto" onload="(function () { setTimeout( function(){ window.document.getElementsByTagName(\'html\')[0].style.display = \'block\'; setTimeout(window.print, 500)}, 10)})()" class="sb-theme"><div>' +
                            ticket + // $('#print-ticket')[0].outerHTML
                            '</div></body></html>',
                    );

                    $($(mywindow.document).find('#print-ticket')).show();
                    $($(mywindow.document).find('.ticket-thread-for-printing')).show();

                    $($(mywindow.document).find('#print-ticket-html .print-hidden')).remove();

                    $($(mywindow.document).find('#print-ticket-html .print-hidden')).remove();

                    $($(mywindow.document).find('#ticket-short-header'))
                        .removeClass('sticky position-static')
                        .removeAttr('style');

                    const styles = $('link[rel="stylesheet"]').clone();

                    try {
                        Array.from(styles).forEach((style) => {
                            let origin = this.windowRef.nativeWindow.location.origin;
                            if (!origin) {
                                origin =
                                    this.windowRef.nativeWindow.location.protocol +
                                    '//' +
                                    this.windowRef.nativeWindow.location.hostname +
                                    (this.windowRef.nativeWindow.location.port
                                        ? ':' + this.windowRef.nativeWindow.location.port
                                        : '');
                            }
                            $(style).attr('href', origin + '/' + $(style).attr('href'));
                        });

                        styles.appendTo($(mywindow.document).find('head'));
                    } catch {}

                    $('head style').clone().appendTo($(mywindow.document).find('head'));

                    const popupWinindow = this.windowRef.nativeWindow.open(
                        '',
                        '_blank',
                        'width=800,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no',
                    );
                    setTimeout(() => {
                        popupWinindow.document.open();
                        popupWinindow.document.write(
                            '<html style="display: none;">' + $(mywindow.document).find('html').html() + '</html>',
                        );
                        popupWinindow.document.close();

                        setTimeout(() => {
                            $('iframe#printf').remove();
                            $('#print-ticket').remove();
                            observer.next(true);
                        }, 2000);
                    }, 600);
                }, 500);
            }, 100);
        });
    }
}
